import { useEffect, useState } from 'react';
import { OwnershipFilterType } from '../components/filters/components/Ownership/types';

export const withOwnership = (query: string | undefined, ownership: string | null | undefined): string => {
    const params = new URLSearchParams(query || '');

    if (ownership) {
        params.set('ownership', ownership.toLowerCase());
    }

    return params.toString();
};

export const useRestoredOwnership = (loadedOwnership: OwnershipFilterType | undefined) => {
    const [restoredOwnership, setRestoredOwnership] = useState<OwnershipFilterType>();

    useEffect(() => {
        if (restoredOwnership && loadedOwnership === restoredOwnership) {
            setRestoredOwnership(undefined);
        }
    }, [loadedOwnership, restoredOwnership]);

    return { ownership: restoredOwnership ?? loadedOwnership, setRestoredOwnership };
};
